// import API from '@/api';
import V3API from '@/api/v3';

const GET_GLOBAL_STATS = 'GET_GLOBAL_STATS';
const GET_GLOBAL_STATS_FAILED = 'GET_GLOBAL_STATS_FAILED';
const GET_GLOBAL_STATS_SUCCESS = 'GET_GLOBAL_STATS_SUCCESS';

const GET_LEADERBOARD_STATS = 'GET_LEADERBOARD_STATS';
const GET_LEADERBOARD_STATS_FAILED = 'GET_LEADERBOARD_STATS_FAILED';
const GET_LEADERBOARD_STATS_SUCCESS = 'GET_LEADERBOARD_STATS_SUCCESS';

// Enabled the module to be namespaced
const namespaced = true;

// Stats initial state
const state = {
  leaderboardStats: {},
  loadingLeaderboardStats: false,
  loading: false,
  globalStats: {},
  loadingGlobalStats: false,
};

// Stats getters
const getters = {
  leaderboardStats: (state) => {
    // console.log('leaderboardStats:', state.leaderboardStats);
    return state.leaderboardStats;
  },

  leaderboardGIR: (state) => {
    return state.leaderboardStats?.gir ?? [];
  },

  leaderboardFairway: (state) => {
    return state.leaderboardStats?.fairway ?? [];
  },

  loadingLeaderboardStats: (state) => {
    return state.loadingLeaderboardStats;
  },

  globalStats: (state) => {
    return state.globalStats;
  },

  loading: (state) => {
    return state.loading;
  },

  loadingGlobalStats: (state) => {
    return state.loadingGlobalStats;
  },
};

// Stats actions
const actions = {
  //* leaderboardList fetches the global leaderboards from the API
  async leaderboardList({ commit }, payload) {
    let response;
    commit(GET_LEADERBOARD_STATS);
    try {
      response = await V3API.stats.leaderboardList();
    } catch (err) {
      response = err;
    }
    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_LEADERBOARD_STATS_FAILED);
        reject(response);
      } else {
        commit(GET_LEADERBOARD_STATS_SUCCESS, response.data);
        // Return GET data  within promise
        resolve(response.data);
      }
    });
  },

  // //* globalStatsList fetches the global stats list from the API
  // async globalStatsList({ commit }, payload) {
  //   let response;
  //   commit(GET_GLOBAL_STATS);
  //   try {
  //     response = await V3API.stats.globalStatsList();
  //   } catch (err) {
  //     response = err;
  //   }
  //   return new Promise((resolve, reject) => {
  //     if (response.status >= 400) {
  //       commit(GET_GLOBAL_STATS_FAILED);
  //       reject(response);
  //     } else {
  //       commit(GET_GLOBAL_STATS_SUCCESS, response.data);
  //       // Return GET data  within promise
  //       resolve(response.data);
  //     }
  //   });
  // },
};

// Stats mutations
const mutations = {
  [GET_LEADERBOARD_STATS](state) {
    state.loadingLeaderboardStats = true;
  },

  [GET_LEADERBOARD_STATS_FAILED](state) {
    state.loadingLeaderboardStats = false;
  },

  [GET_LEADERBOARD_STATS_SUCCESS](state, data) {
    state.leaderboardStats = data;
    state.loadingLeaderboardStats = false;
  },

  [GET_GLOBAL_STATS](state) {
    state.loadingGlobalStats = true;
  },

  [GET_GLOBAL_STATS_FAILED](state) {
    state.loadingGlobalStats = false;
  },

  [GET_GLOBAL_STATS_SUCCESS](state, data) {
    state.globalStats = data;
    state.loadingGlobalStats = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
